function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M69.6,10.43c-.87-.87-2.08-1.28-3.3-1.14-1.84.22-3.49.42-5.12.75-14.81,2.93-24.68,9.16-30.98,19.52-.1.1-.42.23-.51.23-2.16-.32-4.1.23-6.09,1.74-4.56,3.46-8.49,7.79-12,13.24-.43.66-.69,1.36-.98,2.09-.13.33-.26.67-.42,1.04l-.99,2.29,2.48-.2c.33-.03.62-.04.89-.06.56-.03,1.05-.06,1.57-.17,1.47-.32,2.94-.65,4.41-.98,1.37-.31,2.73-.61,4.1-.91-.56,1.42-.47,3.28,2.02,5.14l2.22,2.24c1.65,2.15,3.43,2.86,5.3,2.12-.23,1.04-.47,2.07-.71,3.1-.25,1.08-.5,2.15-.73,3.23-.2.91-.36,1.83-.54,2.87-.09.49-.18,1.02-.28,1.58l-.47,2.57,2.46-.89c.36-.13.69-.23.98-.33.65-.2,1.26-.4,1.84-.75,5.43-3.34,10.04-7.45,13.68-12.21,1.09-1.42,2.28-3.38,1.8-5.98-.07-.4-.13-.68.84-1.21,3.06-1.66,5.9-4.05,8.43-7.09,5.21-6.26,8.61-13.65,10.4-22.58.4-1.99.63-4.02.86-5.98.14-1.22-.28-2.42-1.15-3.29ZM53.51,32.58c-3.29,0-6-2.67-6.08-5.98-.08-3.45,2.66-6.27,6.14-6.32,3.23-.05,6.05,2.81,6.1,6.2.04,3.28-2.8,6.1-6.16,6.1Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M22.24,52.64c-3.42,1.69-4.62,4.67-4.96,8.16-.18,1.86.17,2.27,2.08,2.12,3.51-.29,6.49-1.54,8.17-4.97,1.87,3.45-.31,7.85-4.36,8.55-2.85.49-5.78.48-8.68.68-1.02.07-1.56-.43-1.47-1.47.26-3.14.29-6.33.87-9.41.65-3.49,5.09-5.34,8.35-3.66Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/CrashGames-active.63fd50a7.svg";
export { SvgComponent as ReactComponent };